import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ssnMask'
})
export class SsnMaskPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if(value) {
      return '***-**-' + value.substr(7,4)
    }
  }

}
